module.exports = __webpack_public_path__ + "img/air-9.5848fab0.jpeg";